import React from 'react';
import {Table, Button, Input, Modal, Icon} from 'antd';
import Info from '../Detail/Info';

class MapDetail extends React.Component {
    constructor(props) {
        super();
    }

    state = {
        visible:false
    }

    point = {};

    componentWillMount() {
        window.addEventListener('message', this.postMessage, false);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.postMessage);
    }

    postMessage = (event)=>{
        var loc = event.data;
        console.log(event);
        if (loc && loc.module == 'locationPicker') {

            this.point = {
                latitude:loc.latlng.lat,
                longitude:loc.latlng.lng,
                name:loc.poiaddress + ' ' + loc.poiname
                // name:loc.poiname
            };
        }
    }

    submitHandler = ()=>{
        let {onChange} = this.props;
        var target = this.point;
        console.log(this.point);
        if(target.latitude && target.longitude) {
            this.setState({
                visible:false
            }, ()=>{
                onChange(target);
            });
        }else {
            Modal.warning({
                title:'提示',
                content:'请先选择地点信息，或点击取消关闭地图'
            });
        }
    }

    render() {
        let {value, disabled, onChange} = this.props;

        value = typeof value == 'object' ? value : {};

        var coord = value.latitude * 1 && value.longitude * 1 ? `${value.latitude},${value.longitude}` : "";
        var url = "";
        if(this.state.visible) {
            if(coord) {
                url = "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=6YPBZ-DKRAW-F5ARW-OBCRX-6O6IV-33FOX&referer=jfoto.cn&coord="+coord+"&coordtype=5";
            }else {
                url = "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=6YPBZ-DKRAW-F5ARW-OBCRX-6O6IV-33FOX&referer=jfoto.cn";
            }
        }else {
            url = "about:blank";
        }
        return <div className="mapdetail">
            <Input type="text" readOnly={!(value.longitude && value.latitude)} disabled={disabled}
                value={value.name && value.longitude && value.latitude ? (`${value.name}`) : null}
                placeholder="请点击右侧图标，使用地图选择地址"
                onChange={(e)=>{
                  onChange({
                    longitude:value.longitude,
                    latitude:value.latitude,
                    name:e.target.value
                  });
                }}
                addonAfter={<Icon onClick={()=>!disabled && this.setState({visible:true})} type="pushpin" />}  />

            <Modal visible={this.state.visible} onOk={this.submitHandler} onCancel={()=>this.setState({visible:false})} title="请选择地点">
                <div style={{margin:"0 auto", width:464}}>
                    <iframe id="mapDetailPage" width={464} height={440} frameBorder={0} title={'Map Detail'}
                        src={url}>
                    </iframe>
                </div>
            </Modal>
        </div>;
    }
}

export default MapDetail;



// WEBPACK FOOTER //
// ./src/components/Select/MapDetail.js